import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleWarning = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m10,18c4.411,0,8-3.589,8-8S14.411,2,10,2,2,5.589,2,10s3.589,8,8,8Zm-1-12c0-.552.447-1,1-1s1,.448,1,1v4.5c0,.552-.447,1-1,1s-1-.448-1-1v-4.5Zm1,6.5c.689,0,1.25.561,1.25,1.25s-.561,1.25-1.25,1.25-1.25-.561-1.25-1.25.561-1.25,1.25-1.25Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleWarning.js.map